module.exports = __webpack_public_path__ + "img/47_31.6f67a9b8.png";